/**
 * Client-side order quantity limits by SKU (theme fallback when Admin quantity rules are unavailable).
 * Config: window.themeQuantityLimits = { "A023080": 3 }
 */
window.ThemeQuantityLimits = {
  getMaxForSku(sku) {
    if (!sku) return null;
    const limits = window.themeQuantityLimits || {};
    const max = limits[sku];
    return max == null || max === '' ? null : Number(max);
  },

  quantityErrorMessage(max) {
    const template = (window.cartStrings && window.cartStrings.quantityError) || '';
    return template.replace('[quantity]', String(max));
  },

  async getCartQuantityForSku(sku) {
    if (!sku) return 0;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      return (cart.items || []).reduce((sum, item) => (item.sku === sku ? sum + item.quantity : sum), 0);
    } catch (e) {
      console.error(e);
      return 0;
    }
  },

  async validateAdd(sku, quantityToAdd) {
    const max = this.getMaxForSku(sku);
    if (max == null) return { ok: true };

    const qty = parseInt(quantityToAdd, 10) || 0;
    const inCart = await this.getCartQuantityForSku(sku);
    if (inCart + qty > max) {
      return { ok: false, max, inCart, allowed: Math.max(0, max - inCart) };
    }
    return { ok: true, max, inCart };
  },

  validateLineQuantity(sku, quantity) {
    const max = this.getMaxForSku(sku);
    if (max == null) return { ok: true };
    const qty = parseInt(quantity, 10) || 0;
    if (qty > max) {
      return { ok: false, max, quantity: max };
    }
    return { ok: true, max };
  },
};
